module.exports = __webpack_public_path__ + "img/accounting.8cf235af.svg";